module.exports = __webpack_public_path__ + "static/media/oberflex-freneod728-2560x1440.bdd166d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-freneod728-2560x1440.jpg
// module id = 1025
// module chunks = 37